import { create } from 'zustand';
import type { WorkspaceId } from '@/types';

export type DialogRequest =
  | { readonly kind: 'rename-workspace'; readonly id: WorkspaceId }
  | { readonly kind: 'delete-workspace'; readonly id: WorkspaceId };

/** The one modal dialog that can be open at a time (workspace rename/delete). */
export interface DialogStore {
  readonly request: DialogRequest | null;
  readonly open: (request: DialogRequest) => void;
  readonly close: () => void;
}

export const useDialogStore = create<DialogStore>()((set) => ({
  request: null,
  open: (request) => {
    set({ request });
  },
  close: () => {
    set({ request: null });
  },
}));
